var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 33,
    viewBox: "0 0 28 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_464_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.179198 18.6683L18.1459 0.19394C18.6452 -0.317849 19.4732 0.275079 19.1487 0.911694L12.7534 13.5317C12.705 13.6269 12.6818 13.733 12.6861 13.8398C12.6904 13.9465 12.722 14.0504 12.778 14.1414C12.8339 14.2325 12.9123 14.3076 13.0057 14.3597C13.099 14.4117 13.2041 14.4389 13.3109 14.4387L26.7631 14.4387C26.886 14.4388 27.0061 14.4752 27.1084 14.5433C27.2106 14.6113 27.2906 14.7081 27.3381 14.8214C27.3856 14.9347 27.3987 15.0595 27.3756 15.1802C27.3525 15.3008 27.2943 15.412 27.2083 15.4998L10.544 32.3825C10.0613 32.8714 9.25825 32.3347 9.52663 31.7002L14.3054 20.4346C14.3459 20.3391 14.3619 20.235 14.352 20.1317C14.3421 20.0285 14.3067 19.9293 14.2489 19.8432C14.191 19.7571 14.1127 19.6867 14.0208 19.6385C13.929 19.5903 13.8266 19.5657 13.7229 19.567L0.634814 19.7293C0.511304 19.7313 0.389986 19.6966 0.286216 19.6296C0.182445 19.5625 0.100889 19.4663 0.0518806 19.3529C0.00287202 19.2395 -0.0113871 19.1141 0.0109069 18.9926C0.033201 18.8711 0.0910465 18.7589 0.177119 18.6703",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_464_328",
    x: -0.712318,
    y: -0.713294,
    width: 28.8123,
    height: 33.9991,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.713294,
    dy: 0.713294
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.356647
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.951667 0 0 0 0 0.951667 0 0 0 0 0.951667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_464_328"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.713294,
    dy: -0.713294
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.356647
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_464_328",
    result: "effect2_innerShadow_464_328"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.a709d0046e0d0cb545db8a3ddc6e2f60.svg";
export { ForwardRef as ReactComponent };